// extracted by mini-css-extract-plugin
export default {"mainSec":"styles_mainSec__fBySl","tabContainer":"styles_tabContainer__YpKML","tab":"styles_tab__Mtgqy","activeTab":"styles_activeTab__iRgxm"};